<template>
    <div>
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <span class="field-directions" v-if="directions" v-html="directions"></span>
                <div v-for="(bullet, i) of highlightsArr">
                    <v-text-field
                            v-model="bullet.value"
                            :label="'Bullet '+(i+1)"
                            :error-messages="errors"
                            @keyup="highlightsChanged"
                            required
                    ></v-text-field>
                </div>
                <v-btn
                        text
                        class="mb-3"
                        v-if="highlightsArr.length < 6"
                        color="bw-secondary"
                        @click.prevent="addBullet"
                ><i class="fa fa-plus-circle mr-1"></i> Add a Bullet</v-btn>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin'
import TypeReview from './TypeReview'
// TODO: more validation

export default {
    name: 'TypeHighlights',
    mixins: [formMixin],
    inheritAttrs: false,
    components: {
        TypeReview
    },
    mounted() {
        this.fieldLoaded(); // signal to the form we are loaded
    },
    methods: {
        highlightsChanged() {
            this.highlightsArr = [...this.highlightsArr]; // signal computed
        },
        addBullet() {
            // this.highlightsArr.push({value:''});
            this.innerValue += '\n';
        },
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            }
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {}
        },
        highlightsArr: {
            get() {
                const highlightsArr = (this.innerValue || '').split('\n').map(x => {return {value:x};});
                while (highlightsArr.length < 3) {
                    highlightsArr.push({value:''});
                }
                return highlightsArr;
            },
            set(highlights) {
                this.innerValue = highlights.filter(x=> !!x.value).map(x=> x.value).join('\n');
            }
        },
        hasBullets: {
            get() {
                return !!this.highlightsArr?.length && !!this.highlightsArr.filter(x => x.value).length
            }
        }
    }
}
</script>
